<template>
  <v-container>
    <!-- Used to display instructors list -->
    <!-- <CompanyEmployeeList type="instructor" :title="$t('labels.instructor')" :companyId="Number($route.params.id)" /> -->
    <CompanyEmployeeList
      type="instructor"
      :title="$t('labels.instructor')"
      :isDepartments="hasDepartments($route.params.id)"
      :MessageBoxText="
        $t('company.department-instructor-info') +
        ' ' +
        getCurrentUserDepartments($route.params.id, isAdministrator, false)
      "
      :companyId="Number($route.params.id)"
    />
  </v-container>
</template>

<script>
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'
import {CompanyRoles} from '@/components/mixins'
import {mapGetters} from 'vuex'

// @group Company
// CompanyInstructors component
export default {
  name: 'CompanyInstructors',

  mixins: [CompanyRoles],

  components: {
    CompanyEmployeeList
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator'])
  }
}
</script>

<style lang="scss">
</style>